var generateStyle = function generateStyle(componentTheme) {
  return {
    menuIcon: {
      verticalAlign: 'middle',
      marginRight: componentTheme.menuIconMargin,
      fontSize: componentTheme.menuIconFontSize
    },
    container: {
      height: '100%'
    }
  };
};
export default generateStyle;